import { Tooltip } from '../../../tooltip/Tooltip';
import { Icon } from '../../../icon/Icon';
import { JobStatus } from '../../../jobs/interfaces/job';
import { STATUS_COLOR_MAP } from '../../constants';
import { GenericStatus } from '../../interfaces/generic-status';
import { HeartBeatTooltipContent } from './HeartBeatTooltipContent';

function HeartBeatIndicator({
  updatedAt,
  status
}: {
  updatedAt: number;
  status: GenericStatus<JobStatus>;
}) {
  return (
    <Tooltip dataId='hevo-heartbeat' title={<HeartBeatTooltipContent updatedAt={updatedAt} />}>
      <Icon
        dataId='hevo-heartbeat'
        name='heartbeat'
        className={`mr-3 text-${STATUS_COLOR_MAP[status.colorType]}`}
      />
    </Tooltip>
  );
}

export default HeartBeatIndicator;
